import { request } from '@/common/utils/request'

export function fetchShopCollectInfo (params) {
  return request.post('crm.bdapp.open.apply.get', {
    data: params
  })
}

export function saveShopCollectInfo (params) {
  return request.post('crm.bdapp.open.apply.updateContract', {
    data: params
  }).then(res => res.data)
}

export function sendEmailAndMsg (params) {
  return request.post('crm.bdapp.open.apply.sendMsgGatherUrl', {
    data: params
  }).then(res => res.data)
}

export function initMsgGather (params) {
  return request.post('crm.bdapp.open.apply.initMsgGather', {
    data: params
  })
}
